import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const VideoCard = ({ video }) => {
  const [imageError, setImageError] = useState(false);
  const [imageLoading, setImageLoading] = useState(true);

  const formatDate = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toLocaleDateString('ja-JP');
  };

  const handleImageLoad = () => {
    setImageLoading(false);
    setImageError(false);
  };

  const handleImageError = () => {
    setImageLoading(false);
    setImageError(true);
    console.error(`Failed to load image for ${video.productCode}: ${video.coverImage}`);
  };


  return (
    <div className="video-card border rounded-lg overflow-hidden shadow-sm hover:shadow-md transition-shadow relative">
      {/* Mock indicator */}
      {video.isMock && (
        <div className="absolute top-2 right-2 z-10">
          <span className="bg-blue-100 text-blue-700 px-2 py-1 rounded text-xs font-medium">
            🧪 Mock
          </span>
        </div>
      )}
      
      {/* Source indicator */}
      <div className="absolute top-2 left-2 z-10">
        {video.source === 'MGS' && (
          <span className="bg-red-600 text-white px-2 py-1 rounded text-xs font-bold shadow-sm">
            MGS限定
          </span>
        )}
        {video.source === 'DMM' && (
          <span className="bg-blue-600 text-white px-2 py-1 rounded text-xs font-bold shadow-sm">
            FANZA
          </span>
        )}
        {video.source === 'BOTH' && (
          <span className="bg-purple-600 text-white px-2 py-1 rounded text-xs font-bold shadow-sm">
            MGS+FANZA
          </span>
        )}
      </div>

      <Link to={`/videos/${video.id}`}>
        <div className="aspect-w-2 aspect-h-3 bg-gray-200 relative">
          {imageLoading && (
            <div className="absolute inset-0 flex items-center justify-center">
              <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500"></div>
            </div>
          )}
          
          {video.coverImage && !imageError ? (
            <img 
              src={video.coverImage}
              alt={video.title}
              title={`${video.productCode} - ${video.title}`}
              loading="lazy"
              onLoad={handleImageLoad}
              onError={handleImageError}
              className={`w-full h-full object-cover ${imageLoading ? 'opacity-0' : 'opacity-100'} transition-opacity duration-300`}
              key={`${video.id}-${video.productCode}`}
            />
          ) : (
            <div className="w-full h-full flex flex-col items-center justify-center p-4">
              <span className="text-gray-500 text-sm">No Image</span>
              <span className="text-gray-400 text-xs mt-1">{video.productCode}</span>
            </div>
          )}
        </div>
        
        <div className="p-4">
          <h3 className="text-md font-semibold line-clamp-2 h-12">{video.title}</h3>
          <p className="text-sm text-gray-600 mt-1 font-mono">{video.productCode}</p>
          <p className="text-sm text-gray-500 mt-1">
            {formatDate(video.releaseDate)}
          </p>
          {video.maker && (
            <p className="text-xs text-gray-500 mt-1 truncate">{video.maker}</p>
          )}
        </div>
      </Link>
    </div>
  );
};

export default VideoCard;